import React from 'react'
import { navigate } from 'gatsby'
import { useStoreActions } from 'easy-peasy'

import { Button } from './Button'
import { DocsForm } from './DocsForm'
import { DocsInput } from './DocsInput'
import { ReactComponent as SigninIconSVG } from '../assets/icon-signin.svg'
import { ReactComponent as UserIconSVG } from '../assets/icon-user.svg'
import { ReactComponent as LockIconSVG } from '../assets/icon-lock.svg'
import { ReactComponent as LoaderSVG } from '../assets/svg-loader.svg'

import { SVG, Flex, Link } from 'system'

export const LoginForm = ({ redirectPath }) => {
  const [isError, setIsError] = React.useState(false)
  const [submitted, setSubmitted] = React.useState(false)
  const loginUser = useStoreActions(actions => actions.auth.loginUser)

  const handleSubmit = async e => {
    e.preventDefault()
    const email = e.target.email.value
    const password = e.target.password.value

    setSubmitted(true)

    try {
      await loginUser({ email, password })
      if (redirectPath) navigate(redirectPath)
    } catch {
      setIsError(true)
      setSubmitted(false)
    }
  }

  return (
    <Flex
      bg="purple.100"
      minHeight="100vh"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <DocsForm
        heading="Web CMS Guide"
        description="To view this page, please sign in below:"
        handleSubmit={handleSubmit}
      >
        <DocsInput
          type="text"
          name="email"
          onChange={() => setIsError(false)}
          placeholder="Email"
          isError={isError}
          svg={UserIconSVG}
        />
        <DocsInput
          type="password"
          name="password"
          onChange={() => setIsError(false)}
          placeholder="Password"
          isError={isError}
          svg={LockIconSVG}
        />
        <Link
          ml="auto"
          href="/reference/recover"
          fontSize="small"
          fontStyle="italic"
          color="purple.50"
          css={`
            &:hover {
              text-decoration: underline;
            }
          `}
          mb={2}
        >
          Forgot your password?
        </Link>
        <Button
          type="submit"
          mt={2}
          iconSVG={submitted ? null : SigninIconSVG}
          width="50%"
        >
          {submitted ? (
            <SVG x={1} y={1} svg={LoaderSVG} width="1.25rem" color="white" />
          ) : (
            'Sign In'
          )}
        </Button>
      </DocsForm>
    </Flex>
  )
}

export default LoginForm
